module.exports = __webpack_public_path__ + "4be5d3d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/img/new/support.png
// module id = 700
// module chunks = 1